<template>
  <v-tooltip bottom>
    <template v-slot:activator="{ on }">
      <v-chip
        dark
        v-if="value"
        v-on="on"
        :color="getColor"
        :small="small"
        class="elevation-0"
        @click="onClickPremiumLock"
      >
        <v-icon :small="small">lock</v-icon>
        <slot></slot>
      </v-chip>
    </template>
    <span>
      <template v-if="type == 'premium'">{{
        $t('Upgrade to {package} Plan', { package: $t('PREMIUM') })
      }}</template>
      <template v-else-if="type == 'advanced'">
        {{ text === '' ? $t('Upgrade to {package} Plan', { package: $t('ADVANCED') }) : $t(text) }}
      </template>
      <template v-else-if="type == 'business'">
        {{ text === '' ? $t('Upgrade to {package} Plan', { package: $t('business') }) : $t(text) }}
      </template>
    </span>
  </v-tooltip>
</template>

<script>
export default {
  props: {
    value: {
      default: true
    },
    type: {
      default: 'premium'
    },
    small: {
      default: true
    },
    text: {
      default: ''
    },
    url: {
      default: null
    }
  },
  computed: {
    getColor() {
      switch (this.type) {
        case 'premium':
          return '#27c2e0'
        case 'advanced':
          return 'amber'
        case 'business':
          return 'rgb(176, 27, 93)'
        default:
          return ''
      }
    }
  },
  methods: {
    onClickPremiumLock() {
      const vm = this
      if (vm.url) {
        window.open(vm.url)
      } else {
        vm.$router.push({
          name: 'Upgrade',
          path: '/upgrade'
        })
      }
    }
  }
}
</script>

<style lang="scss" scoped></style>



// WEBPACK FOOTER //
// src/components/elements/PremiumLock2.vue